import { render } from "./DownloadListButtonGroup.vue?vue&type=template&id=1c311f66"
import script from "./DownloadListButtonGroup.vue?vue&type=script&lang=js"
export * from "./DownloadListButtonGroup.vue?vue&type=script&lang=js"
script.render = render

export default script